import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import PaymentPage from './PaymentPage';
import QrisPage from "./QrisPage";
import PaymentStatusPage from "./PaymentStatusPage";
import RegionPage from "./RegionPage";
import FloatingWhatsApp from './whatsapp/FloatingWhatsApp';
import DestinationsPage from "./destinations/DestinationsPage";
import BottomNav from './bottom/BottomNav';
import ProfilePage from "./profile/ProfilePage";
import EsimPage from "./esim/EsimPage";
import InstallEsimPage from "./esim/InstallEsimPage";
import AuthCallback from "./auth/AuthCallback";
import EsimDetailPage from "./esim/EsimDetailsPage";
import EsimDetailsPageV2 from "./esim/EsimDetailsPageV2";
import KuotaPage from "./kuota/KuotaPage";
import RefundRequestPage from "./refund/RefundRequestPage";
import RefundStatusPage from "./refund/RefundStatusPage";
import PageViewTracker from './analytics/PageViewTracker';
import MetaPixelAdvancedMatching from './analytics/MetaPixelAdvancedMatching';


function AppContent() {
    const { pathname } = useLocation();
    const hideWhatsApp = pathname.startsWith('/product/');

    return (
        <>
            <PageViewTracker />
            <MetaPixelAdvancedMatching />
            {!hideWhatsApp && <FloatingWhatsApp />}
            <Routes>
                <Route path="/" element={<DestinationsPage />} />
                <Route path="/product/:productCode" element={<PaymentPage />} />
                <Route path="/qris" element={<QrisPage />} />
                <Route path="/payment-status" element={<PaymentStatusPage />} />
                <Route path="/region/:regionCode" element={<RegionPage />} />
                <Route path="/profile" element={<ProfilePage />} />
                <Route path="/esims" element={<EsimPage />} />
                <Route path="/auth-callback" element={<AuthCallback />} />
                <Route path="/esims/:iccid" element={<EsimDetailPage />} />
                <Route path="/sim/:SimId" element={<EsimDetailsPageV2 />} />
                <Route path="/sim/:SimId/refund" element={<RefundRequestPage />} />
                <Route path="/sim/:SimId/refund/status" element={<RefundStatusPage />} />
                <Route path="/esims/install" element={<InstallEsimPage />} />
                <Route path="/kuota" element={<KuotaPage />} />
            </Routes>
            {/* Bottom navigation bar - always visible */}
            <BottomNav />
        </>
    );
}

function App() {
    return (
        <Router>
            <AppContent />
        </Router>
    );
}

export default App;